import angular from 'angular'

import { isText } from '../utils/bits'
import { includes } from 'lodash-es'

import envRaw from '../utils/env-raw'
import debugRaw from '../utils/debug-raw'

debugRaw({
  runUnimportantStylesScanner,
  runWrongTextDirScanner,
  runSuspiciousLinkScanner,
  runSuspiciousIframeScanner,
  runExposedAngularScanner,
  runUnstrictModeScanner
})

if (envRaw.devMode) {
  setTimeout(() => {
    runUnimportantStylesScanner()
    runWrongTextDirScanner()
    runSuspiciousLinkScanner()
    runSuspiciousIframeScanner()
    runExposedAngularScanner()
    runUnstrictModeScanner()
  }, 5e3)

  setInterval(() => {
    runUnimportantStylesScanner()
    runWrongTextDirScanner()
    runSuspiciousLinkScanner()
    runSuspiciousIframeScanner()
    runExposedAngularScanner()
    runUnstrictModeScanner()
  }, 10e3)
}

function runUnimportantStylesScanner() {
  const excludeTypes = [
    window.CSSRule.FONT_FACE_RULE,
    window.CSSRule.KEYFRAME_RULE
  ]

  const regexpSelectors = [
    /\.ggsi/
  ]

  const excludeSelectors = [
    '.ggsi, .ggsi a, .ggsi b, .ggsi button, .ggsi div, .ggsi i, .ggsi iframe, .ggsi img, .ggsi p, .ggsi s, .ggsi span, .ggsi textarea, .ggsi u, .ggsi video'
  ]

  const excludeProperties = [
    'animation',
    'animation-name',
    'animation-duration',
    'animation-timing-function',
    'animation-delay',
    'animation-iteration-count',
    'animation-direction',
    'animation-fill-mode',
    'animation-play-state'
  ]

  for (const styleSheet of document.styleSheets) {
    if (isStyleSheetAvailable(styleSheet)) {
      digCssRules(styleSheet.cssRules)
    }
  }

  function isStyleSheetAvailable(styleSheet) {
    try {
      return !!styleSheet.cssRules
    } catch (_err) {
      return false
    }
  }

  function digCssRules(cssRules) {
    for (const cssRule of cssRules) {
      if (cssRule.cssRules) {
        digCssRules(cssRule.cssRules)
      } else {
        checkCssRule(cssRule)
      }
    }
  }

  function checkCssRule(cssRule) {
    if (includes(excludeTypes, cssRule.type)) return
    if (includes(excludeSelectors, cssRule.selectorText)) return
    if (!regexpSelectors.some((regexpSelector) => regexpSelector.test(cssRule.selectorText))) return

    let problem = null
    for (const property of cssRule.style) {
      if (includes(excludeProperties, property)) continue
      const priority = cssRule.style.getPropertyPriority(property)
      if (priority !== 'important') {
        problem = property
        break
      }
    }

    if (problem) {
      console.warn(`cssRule contains [property=${problem}] with an incorrect priority! cssRule:`, cssRule)
    }
  }
}

function runWrongTextDirScanner() {
  if (!runWrongTextDirScanner.__cache__) runWrongTextDirScanner.__cache__ = []
  const cache = runWrongTextDirScanner.__cache__

  const roots = document.querySelectorAll('.ggsi')
  const excludeDirs = ['rtl', 'ltr']
  const excludeNodes = ['STYLE', 'TEXTAREA']
  find(roots, excludeDirs, excludeNodes)

  function find(elms, excludeDirs, excludeNodes) {
    for (const elm of elms) {
      const requiresCheck = true
        && elm.nodeType === 3
        && isText(elm.textContent)
        && elm.parentNode
        && excludeDirs.indexOf(elm.parentNode.getAttribute('dir')) === -1
        && excludeNodes.indexOf(elm.parentNode.nodeName) === -1

      const requiresFind = true
        && elm.childNodes
        && elm.childNodes !== 0

      if (requiresCheck) {
        check(elm.parentNode)
      }

      if (requiresFind) {
        find(elm.childNodes, excludeDirs, excludeNodes)
      }
    }
  }

  function check(elm) {
    if (includes(cache, elm)) return
    cache.push(elm)

    const text = document.createElement('div')
    text.setAttribute('dir', 'auto')
    text.textContent = elm.textContent
    document.body.appendChild(text)
    const textDir = window.getComputedStyle(text).direction
    document.body.removeChild(text)
    const elmDir = window.getComputedStyle(elm).direction
    if (elmDir !== textDir) {
      console.warn(`Element might display text in the wrong direction! textDir: ${textDir}, elmDir: ${elmDir}, elm:`, elm)
    }
  }
}

function runSuspiciousLinkScanner() {
  const elms = document.querySelectorAll('.ggsi a')

  for (const elm of elms) {
    const target = elm.getAttribute('target') === '_blank'
    const tabindex = elm.getAttribute('tabindex') === '-1'
    const noopener = includes(elm.getAttribute('rel'), 'noopener')
    const noreferrer = includes(elm.getAttribute('rel'), 'noreferrer')

    if (!target || !tabindex || !noopener || !noreferrer) {
      console.warn(`Link is suspicious! target: ${target}, tabindex: ${tabindex}, noopener: ${noopener}, noreferrer: ${noreferrer}, elm:`, elm)
    }
  }
}

function runSuspiciousIframeScanner() {
  const elms = document.querySelectorAll('.ggsi iframe')

  for (const elm of elms) {
    const tabindex = elm.getAttribute('tabindex') === '-1'
    if (!tabindex) {
      console.warn(`Iframe is suspicious! tabindex: ${tabindex}, elm:`, elm)
    }
  }
}

function runExposedAngularScanner() {
  if (angular === window.angular) {
    console.error('GGS ANGULAR SHOULD NOT BE EXPOSED!')
  }
}

function runUnstrictModeScanner() {
  if (this !== undefined) {
    console.error('GGS MODULES SHOULD BE RUN IN STRICT MODE!')
  }
}
